export default (componentId) => ({
  methods: {
    getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    },
    eventPropertiesReplacer(eventProperties, matchPatterns) {
      let eventPropertiesAsString = JSON.stringify(eventProperties);

      for (const [key, replaceValue] of Object.entries(matchPatterns)) {
        eventPropertiesAsString = eventPropertiesAsString.replaceAll(key, replaceValue);
      }
      return JSON.parse(eventPropertiesAsString);
    },
    pushToDataLayer(eventProperties) {
      if (!window.wsf) {
        window.wsf = {};
      }
      const { refappMoreinformation, refappRR, ecommerce } = window.wsf;
      const rfpReviewFilterObject = new Promise((resolve, reject) => {
        setTimeout(() => {
          if (refappMoreinformation) {
            const matchPatterns = {
              '[product name]': refappMoreinformation.productName
                ? refappMoreinformation.productName.toLocaleLowerCase()
                : '',
              '[product id]': refappMoreinformation.productId
                ? refappMoreinformation.productId
                : '',
              '[page category]': refappMoreinformation.pageCategory
                ? refappMoreinformation.pageCategory
                : '',
              '[write review button text]':
                refappRR && refappRR.writeReviewButtonText
                  ? refappRR.writeReviewButtonText.toLocaleLowerCase()
                  : '',
              '[review list sort data]':
                refappRR && refappRR.reviewListSortData
                  ? refappRR.reviewListSortData.toLocaleLowerCase()
                  : '',
              '[review list filter star]':
                refappRR && refappRR.reviewListfilterStar ? refappRR.reviewListfilterStar : '',
              '[review submit overall rating]':
                refappRR && refappRR.reviewSubmitOverallRating
                  ? refappRR.reviewSubmitOverallRating
                  : '',
              '[review selection]':
                refappRR && refappRR.reviewListSortData
                  ? refappRR.reviewListSortData.toLocaleLowerCase()
                  : '',
            };
            resolve(matchPatterns);
          } else {
            reject('Error: refappMoreinformation is undefined');
          }
        }, 100);
      });

      rfpReviewFilterObject
        .then((matchPatterns) => {
          if (this.getKeyByValue(eventProperties, '[ecommerce]') !== undefined) {
            eventProperties[this.getKeyByValue(eventProperties, '[ecommerce]')] = ecommerce || '';
          }
          if (!window.dataLayer) return null;
          window.dataLayer.push(this.eventPropertiesReplacer(eventProperties, matchPatterns));
          return true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getTaggingEventName() {
      return 'rfpTaggingPushToDatalayer#ratingsAndReview#' + componentId;
    },
  },
  created() {
    window.eventBus.$on(this.getTaggingEventName(), (eventProperties) => {
      this.pushToDataLayer(eventProperties);
    });
  },
});
